import React from 'react';
import styled from 'styled-components';
import { useAppState } from '../../../../data';


const Key = styled.div`
  width: 30%;
  float: left;
  font-size: 1em;
  padding: 5px 0;
`;

const Value = styled.div`
  width: 70%;
  float: left;
  word-break: break-word;
  font-size: 1em;
  padding: 5px 0;
`;

export default function CookieDetail({ cookie }: { cookie: any }) {
  const { getTranslation } = useAppState();
  return (
    <>
      <ldiv>
        <Key>{getTranslation('COOKIE_DETAIL_NAME')}</Key>
        <Value>{cookie.name}</Value>
      </ldiv>
      <ldiv>
        <Key>{getTranslation('COOKIE_DETAIL_HOST')}</Key>
        <Value>{cookie.host}</Value>
      </ldiv>
      <ldiv>
        <Key>{getTranslation('COOKIE_DETAIL_DURATION')}</Key>
        <Value>{cookie.duration}</Value>
      </ldiv>
      <ldiv>
        <Key>{getTranslation('COOKIE_DETAIL_CATEGORY')}</Key>
        <Value>{cookie.category}</Value>
      </ldiv>
    </>
  )
}